const links = document.querySelectorAll('a');
links.forEach(link => {
    if (link.href.startsWith('http') && !link.href.includes(window.location.hostname)
        && !link.href.includes('mailto:') && !link.href.includes('tel:')) {
        link.setAttribute('target', '_blank');
    }
});
